import React from "react";
import moment from "moment";
import Modal from "react-modal";
import StyledModal from "../../../common/Modal/StyledModal";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "47%",
    borderRadius: "30px",
  },
};

/** Pharmacy warning when actioning an older PAF submission date. */
export function PafAgeWarningModal({
  isOpen,
  onClose,
  onRejectAndRequest,
  pfaIssuedDate,
}) {
  return (
    <StyledModal>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        style={modalStyles}
        contentLabel="Warning Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false}
      >
        <div className="wrapper-modal" data-testid="paf-confirm-age-warning-modal">
          <div className="main-text" data-testid="paf-confirm-age-warning-title">
            Are you sure?
          </div>
          <div
            className="second-text"
            data-testid="paf-confirm-age-warning-description"
          >
            <span>
              You are actioning a PAF submitted by a prescriber date on{" "}
              <span className="bold">
                {moment(pfaIssuedDate).format("DD / MM / YYYY")}
              </span>
              . If you are facilitating a prescription on a more recent date,
              please reject and request that the prescriber generates a new
              record.
            </span>
          </div>

          <div
            className="flex-center gap-4"
            data-testid="paf-confirm-age-warning-actions"
          >
            <button
              className="white-button"
              onClick={onClose}
              data-testid="paf-confirm-age-warning-continue-button"
            >
              No, Continue to PAF
            </button>
            <button
              className="second-button font-size-20"
              onClick={onRejectAndRequest}
              data-testid="paf-confirm-age-warning-reject-button"
            >
              Yes, Reject and Request
            </button>
          </div>
        </div>
      </Modal>
    </StyledModal>
  );
}
